// Real images from debsartdesigns.com
const services = [
  {
    number: '01',
    title: 'Custom Artwork',
    sub: 'Your vision. Your colors. Your story.',
    image: 'https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/21a6f67e-20ce-43ba-bef6-b28936fce2eb/3V9A0070.jpg',
    tag: 'Bespoke',
  },
  {
    number: '02',
    title: 'Storybook Sessions',
    sub: 'Imaginative worlds brought to life through art.',
    image: 'https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/1728142754373-88DARSDMGF9FCHPNL0OH/rabbit+and+hatter.jpg',
    tag: 'Fantasy',
  },
  {
    number: '03',
    title: 'Commissioned Designs',
    sub: 'Collaborative. Intentional. Entirely yours.',
    image: 'https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/a4a287c7-e66b-4c28-a152-7f422ef616eb/boy+fairy+with+red+dragon.jpg',
    tag: 'Commission',
  },
  {
    number: '04',
    title: 'Fine Art Prints',
    sub: 'Heirloom-quality pieces to cherish forever.',
    image: 'https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/1728142634188-758IT1T9ESRJHEOOJ2NJ/A+Madd+Tea+Party.jpg',
    tag: 'Original',
  },
];

const ServicesSection = () => (
  <section id="services" className="w-full bg-[#F5F1EB] py-32 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-24">
        <div>
          <div className="flex items-center gap-5 mb-8">
            <div className="w-16 h-px bg-[#C9A96E]/60"></div>
            <span className="text-[#C9A96E]/70 uppercase tracking-[0.5em] text-[9px] font-light">The Collection</span>
          </div>
          <h2 className="font-serif text-[#1A1612]/85 leading-[0.9] tracking-[-0.01em]" style={{ fontSize: 'clamp(3rem, 6vw, 5.5rem)', fontWeight: 300 }}>
            What We<br />
            <em className="italic text-[#C9A96E]" style={{ fontWeight: 300 }}>Create</em>
          </h2>
        </div>
        <p className="text-[#1A1612]/40 text-xs leading-[2.2] max-w-[260px] tracking-[0.06em] font-light">
          Every offering is a commitment to originality. No mass production — only intentional, handmade work.
        </p>
      </div>

      {/* Gallery grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {services.map((s) => (
          <div key={s.title} className="group relative overflow-hidden cursor-pointer" style={{ height: '560px' }}>
            <img
              src={s.image}
              alt={s.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-1000 ease-out group-hover:scale-110"
            />
            {/* Lighter gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1612]/85 via-[#1A1612]/15 to-transparent"></div>
            <div className="absolute inset-0 bg-[#1A1612]/20 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

            {/* Number */}
            <div className="absolute top-7 left-7 z-10">
              <span className="font-serif text-white/15 text-6xl leading-none select-none group-hover:text-[#C9A96E]/30 transition-colors duration-700" style={{ fontWeight: 200 }}>{s.number}</span>
            </div>

            {/* Tag */}
            <div className="absolute top-7 right-7 z-10">
              <span className="text-[9px] uppercase tracking-[0.4em] text-white/40 border border-white/20 px-3 py-1.5 font-light group-hover:border-[#C9A96E]/50 group-hover:text-[#C9A96E]/80 transition-all duration-500">{s.tag}</span>
            </div>

            {/* Content */}
            <div className="absolute bottom-0 left-0 right-0 z-10 p-8">
              <h3 className="font-serif text-white text-2xl mb-2 leading-tight" style={{ fontWeight: 300 }}>{s.title}</h3>
              <p className="text-white/50 text-xs leading-relaxed font-light tracking-wide opacity-0 group-hover:opacity-100 transition-opacity duration-500 mb-4">{s.sub}</p>
              <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-100">
                <div className="w-8 h-px bg-[#C9A96E]/80"></div>
                <span className="text-[#C9A96E]/90 text-[9px] uppercase tracking-[0.4em] font-light">Explore</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="flex justify-center mt-20">
        <button
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          className="whitespace-nowrap flex items-center gap-6 text-[#1A1612]/40 text-[10px] font-light uppercase tracking-[0.5em] hover:text-[#C9A96E] transition-all duration-500 cursor-pointer group"
        >
          <div className="w-12 h-px bg-[#1A1612]/20 group-hover:bg-[#C9A96E]/60 group-hover:w-20 transition-all duration-500"></div>
          Begin Your Custom Project
          <div className="w-12 h-px bg-[#1A1612]/20 group-hover:bg-[#C9A96E]/60 group-hover:w-20 transition-all duration-500"></div>
        </button>
      </div>
    </div>
  </section>
);

export default ServicesSection;
